import { stringifyr } from '@epihub/core/src/stringifyr/core';
import type { Model } from './model';

export const sfyr = stringifyr.model<
  Model,
  {
    lang: string;
  }
>(({ z }) => ({
  context: {
    lang: 'en',
  },
  schema: {
    'landing.{lang}.hero.subtitle': { type: z.string() },
    'landing.{lang}.hero.subtitle_prefix': { type: z.string() },
    'landing.{lang}.hero.subtitle_highlight': { type: z.string() },
    'landing.{lang}.hero.subtitle_suffix': { type: z.string() },
    'landing.{lang}.hero.cta_quote': { type: z.string() },
    'landing.{lang}.about.label': { type: z.string() },
    'landing.{lang}.about.title': { type: z.string() },
    'landing.{lang}.about.paragraph_1': { type: z.string() },
    'landing.{lang}.workflow.label': { type: z.string() },
    'landing.{lang}.workflow.title': { type: z.string() },
    'landing.{lang}.workflow.step_1.title': { type: z.string() },
    'landing.{lang}.workflow.step_1.description': { type: z.string() },
    'landing.{lang}.workflow.step_2.title': { type: z.string() },
    'landing.{lang}.workflow.step_2.description': { type: z.string() },
    'landing.{lang}.workflow.step_3.title': { type: z.string() },
    'landing.{lang}.workflow.step_3.description': { type: z.string() },
    'landing.{lang}.workflow.step_4.title': { type: z.string() },
    'landing.{lang}.workflow.step_4.description': { type: z.string() },
    'landing.{lang}.workflow.step_5.title': { type: z.string() },
    'landing.{lang}.workflow.step_5.description': { type: z.string() },
    'landing.{lang}.blog.label': { type: z.string() },
    'landing.{lang}.blog.title': { type: z.string() },
    'landing.{lang}.blog.subtitle': { type: z.string() },
    'landing.{lang}.blog.view_all': { type: z.string() },
    'landing.{lang}.blog.empty': { type: z.string() },
    'landing.{lang}.blog.back': { type: z.string() },
    'landing.{lang}.testimonial.quote': { type: z.string() },
    'landing.{lang}.testimonial.name': { type: z.string() },
    'landing.{lang}.testimonial.role': { type: z.string() },
    'landing.{lang}.cta.title': { type: z.string() },
    'landing.{lang}.cta.subtitle': { type: z.string() },
    'landing.{lang}.cta.button': { type: z.string() },
    'landing.{lang}.nav.home': { type: z.string() },
    'landing.{lang}.nav.about': { type: z.string() },
    'landing.{lang}.nav.blog': { type: z.string() },
    'landing.{lang}.nav.quote': { type: z.string() },
    'landing.{lang}.footer.tagline': { type: z.string() },
    'landing.{lang}.footer.nav_heading': { type: z.string() },
    'landing.{lang}.footer.legal_heading': { type: z.string() },
    'landing.{lang}.footer.contact_heading': { type: z.string() },
    'landing.{lang}.footer.privacy': { type: z.string() },
    'landing.{lang}.footer.terms': { type: z.string() },
    'landing.{lang}.footer.request_quote': { type: z.string() },
    'landing.{lang}.footer.copyright': { type: z.string() },
  },
}));

sfyr('landing.{lang}.hero.subtitle', {
  defaults: {
    'landing.{lang=it}.hero.subtitle': 'Web, mobile, AI — progettiamo e realizziamo software che funziona.',
    'landing.{lang=en}.hero.subtitle': 'Web, mobile, AI — we design and ship software that works.',
  },
});

sfyr('landing.{lang}.hero.subtitle_prefix', {
  defaults: {
    'landing.{lang=it}.hero.subtitle_prefix': 'Web, mobile, AI — progettiamo e realizziamo ',
    'landing.{lang=en}.hero.subtitle_prefix': 'Web, mobile, AI — we design and ship ',
  },
});

sfyr('landing.{lang}.hero.subtitle_highlight', {
  defaults: {
    'landing.{lang=it}.hero.subtitle_highlight': 'software che funziona',
    'landing.{lang=en}.hero.subtitle_highlight': 'software that works',
  },
});

sfyr('landing.{lang}.hero.subtitle_suffix', {
  defaults: {
    'landing.{lang=it}.hero.subtitle_suffix': '.',
    'landing.{lang=en}.hero.subtitle_suffix': '.',
  },
});

sfyr('landing.{lang}.hero.cta_quote', {
  defaults: {
    'landing.{lang=it}.hero.cta_quote': 'Richiedi un preventivo',
    'landing.{lang=en}.hero.cta_quote': 'Request a quote',
  },
});

sfyr('landing.{lang}.about.label', {
  defaults: {
    'landing.{lang=it}.about.label': 'Chi siamo',
    'landing.{lang=en}.about.label': 'About us',
  },
});

sfyr('landing.{lang}.about.title', {
  defaults: {
    'landing.{lang=it}.about.title': 'Chi siamo',
    'landing.{lang=en}.about.title': 'Who we are',
  },
});

sfyr('landing.{lang}.about.paragraph_1', {
  defaults: {
    'landing.{lang=it}.about.paragraph_1':
      'Realizziamo siti web, piattaforme e strumenti basati su AI. Lavoriamo con te per capire il problema e costruire la soluzione giusta.',
    'landing.{lang=en}.about.paragraph_1':
      'We build websites, platforms, and AI-powered tools. We work closely with you to understand the problem and ship the right solution.',
  },
});

sfyr('landing.{lang}.workflow.label', {
  defaults: {
    'landing.{lang=it}.workflow.label': 'Come lavoriamo',
    'landing.{lang=en}.workflow.label': 'How we work',
  },
});

sfyr('landing.{lang}.workflow.title', {
  defaults: {
    'landing.{lang=it}.workflow.title': "Il nostro processo, dall'idea al lancio",
    'landing.{lang=en}.workflow.title': 'Our process, from idea to launch',
  },
});

sfyr('landing.{lang}.workflow.step_1.title', {
  defaults: {
    'landing.{lang=it}.workflow.step_1.title': 'Analisi e Concept',
    'landing.{lang=en}.workflow.step_1.title': 'Analysis & Concept',
  },
});

sfyr('landing.{lang}.workflow.step_1.description', {
  defaults: {
    'landing.{lang=it}.workflow.step_1.description':
      'Comprendiamo le tue esigenze, analizziamo il mercato e definiamo il concept del progetto. Ti forniamo un preventivo dettagliato con tempistiche chiare.',
    'landing.{lang=en}.workflow.step_1.description':
      'We understand your needs, analyze the market, and define the project concept. We provide a detailed quote with clear timelines.',
  },
});

sfyr('landing.{lang}.workflow.step_2.title', {
  defaults: {
    'landing.{lang=it}.workflow.step_2.title': 'Design e Prototipazione',
    'landing.{lang=en}.workflow.step_2.title': 'Design & Prototyping',
  },
});

sfyr('landing.{lang}.workflow.step_2.description', {
  defaults: {
    'landing.{lang=it}.workflow.step_2.description':
      "Creiamo wireframe e prototipi interattivi per validare l'esperienza utente prima dello sviluppo. Il tuo feedback guida ogni decisione.",
    'landing.{lang=en}.workflow.step_2.description':
      'We create wireframes and interactive prototypes to validate the user experience before development. Your feedback guides every decision.',
  },
});

sfyr('landing.{lang}.workflow.step_3.title', {
  defaults: {
    'landing.{lang=it}.workflow.step_3.title': 'Sviluppo',
    'landing.{lang=en}.workflow.step_3.title': 'Development',
  },
});

sfyr('landing.{lang}.workflow.step_3.description', {
  defaults: {
    'landing.{lang=it}.workflow.step_3.description':
      'Il nostro team sviluppa il prodotto utilizzando tecnologie moderne e best practice. Aggiornamenti regolari e demo intermedie.',
    'landing.{lang=en}.workflow.step_3.description':
      'Our team develops the product using modern technologies and best practices. Regular updates and intermediate demos.',
  },
});

sfyr('landing.{lang}.workflow.step_4.title', {
  defaults: {
    'landing.{lang=it}.workflow.step_4.title': 'Test e QA',
    'landing.{lang=en}.workflow.step_4.title': 'Testing & QA',
  },
});

sfyr('landing.{lang}.workflow.step_4.description', {
  defaults: {
    'landing.{lang=it}.workflow.step_4.description':
      'Testing rigoroso su ogni piattaforma target. Funzionalità, performance e sicurezza vengono verificate prima del lancio.',
    'landing.{lang=en}.workflow.step_4.description':
      'Rigorous testing on every target platform. Functionality, performance, and security are verified before launch.',
  },
});

sfyr('landing.{lang}.workflow.step_5.title', {
  defaults: {
    'landing.{lang=it}.workflow.step_5.title': 'Lancio e Supporto',
    'landing.{lang=en}.workflow.step_5.title': 'Launch & Support',
  },
});

sfyr('landing.{lang}.workflow.step_5.description', {
  defaults: {
    'landing.{lang=it}.workflow.step_5.description':
      'Pubblicazione sulla piattaforma scelta e supporto post-lancio. Siamo disponibili per aggiornamenti, manutenzione e nuove funzionalità.',
    'landing.{lang=en}.workflow.step_5.description':
      'Publishing on the chosen platform and post-launch support. We are available for updates, maintenance, and new features.',
  },
});

sfyr('landing.{lang}.blog.label', {
  defaults: {
    'landing.{lang=it}.blog.label': 'Blog',
    'landing.{lang=en}.blog.label': 'Blog',
  },
});

sfyr('landing.{lang}.blog.title', {
  defaults: {
    'landing.{lang=it}.blog.title': 'Ultimi dal blog',
    'landing.{lang=en}.blog.title': 'Latest from the blog',
  },
});

sfyr('landing.{lang}.blog.subtitle', {
  defaults: {
    'landing.{lang=it}.blog.subtitle': 'Approfondimenti su sviluppo software, tecnologia e strategia digitale.',
    'landing.{lang=en}.blog.subtitle': 'Insights on software development, technology, and digital strategy.',
  },
});

sfyr('landing.{lang}.blog.view_all', {
  defaults: {
    'landing.{lang=it}.blog.view_all': 'Vedi tutti gli articoli',
    'landing.{lang=en}.blog.view_all': 'View all posts',
  },
});

sfyr('landing.{lang}.blog.empty', {
  defaults: {
    'landing.{lang=it}.blog.empty': 'Nessun articolo ancora. Torna presto!',
    'landing.{lang=en}.blog.empty': 'No blog posts yet. Check back soon!',
  },
});

sfyr('landing.{lang}.blog.back', {
  defaults: {
    'landing.{lang=it}.blog.back': 'Torna al Blog',
    'landing.{lang=en}.blog.back': 'Back to Blog',
  },
});

sfyr('landing.{lang}.testimonial.quote', {
  defaults: {
    'landing.{lang=it}.testimonial.quote':
      'Sempre molto attenti ai miei bisogni e pronti a propormi soluzioni intelligenti. Ho trovato molta flessibilità e trasparenza nel modo di lavorare.',
    'landing.{lang=en}.testimonial.quote':
      'Always very attentive to my needs and ready to propose intelligent solutions. I found a lot of flexibility and transparency in the way of working.',
  },
});

sfyr('landing.{lang}.testimonial.name', {
  defaults: {
    'landing.{lang=it}.testimonial.name': 'Giorgia P.',
    'landing.{lang=en}.testimonial.name': 'Giorgia P.',
  },
});
sfyr('landing.{lang}.testimonial.role', {
  defaults: {
    'landing.{lang=it}.testimonial.role': 'Founder @ Penelope Skin',
    'landing.{lang=en}.testimonial.role': 'Founder @ Penelope Skin',
  },
});

sfyr('landing.{lang}.cta.title', {
  defaults: {
    'landing.{lang=it}.cta.title': 'Hai un progetto in mente?',
    'landing.{lang=en}.cta.title': 'Have a project in mind?',
  },
});

sfyr('landing.{lang}.cta.subtitle', {
  defaults: {
    'landing.{lang=it}.cta.subtitle':
      'Parlaci della tua idea. Ti forniremo un preventivo dettagliato con tempistiche e costi chiari. Nessun impegno.',
    'landing.{lang=en}.cta.subtitle':
      'Tell us about your idea. We will provide a detailed quote with clear timelines and costs. No commitment.',
  },
});

sfyr('landing.{lang}.cta.button', {
  defaults: {
    'landing.{lang=it}.cta.button': 'Contattaci',
    'landing.{lang=en}.cta.button': 'Contact us',
  },
});

sfyr('landing.{lang}.nav.home', {
  defaults: { 'landing.{lang=it}.nav.home': 'Home', 'landing.{lang=en}.nav.home': 'Home' },
});
sfyr('landing.{lang}.nav.about', {
  defaults: { 'landing.{lang=it}.nav.about': 'Chi siamo', 'landing.{lang=en}.nav.about': 'About' },
});
sfyr('landing.{lang}.nav.blog', {
  defaults: { 'landing.{lang=it}.nav.blog': 'Blog', 'landing.{lang=en}.nav.blog': 'Blog' },
});
sfyr('landing.{lang}.nav.quote', {
  defaults: { 'landing.{lang=it}.nav.quote': 'Preventivo', 'landing.{lang=en}.nav.quote': 'Quote' },
});

sfyr('landing.{lang}.footer.tagline', {
  defaults: {
    'landing.{lang=it}.footer.tagline': 'Studio software con sede a Brescia, Italia.',
    'landing.{lang=en}.footer.tagline': 'Software studio based in Brescia, Italy.',
  },
});

sfyr('landing.{lang}.footer.nav_heading', {
  defaults: {
    'landing.{lang=it}.footer.nav_heading': 'Navigazione',
    'landing.{lang=en}.footer.nav_heading': 'Navigation',
  },
});
sfyr('landing.{lang}.footer.legal_heading', {
  defaults: { 'landing.{lang=it}.footer.legal_heading': 'Legale', 'landing.{lang=en}.footer.legal_heading': 'Legal' },
});
sfyr('landing.{lang}.footer.contact_heading', {
  defaults: {
    'landing.{lang=it}.footer.contact_heading': 'Contatti',
    'landing.{lang=en}.footer.contact_heading': 'Contact',
  },
});
sfyr('landing.{lang}.footer.privacy', {
  defaults: {
    'landing.{lang=it}.footer.privacy': 'Privacy Policy',
    'landing.{lang=en}.footer.privacy': 'Privacy Policy',
  },
});
sfyr('landing.{lang}.footer.terms', {
  defaults: {
    'landing.{lang=it}.footer.terms': 'Termini di Servizio',
    'landing.{lang=en}.footer.terms': 'Terms of Service',
  },
});
sfyr('landing.{lang}.footer.request_quote', {
  defaults: {
    'landing.{lang=it}.footer.request_quote': 'Richiedi preventivo',
    'landing.{lang=en}.footer.request_quote': 'Request quote',
  },
});
sfyr('landing.{lang}.footer.copyright', {
  defaults: {
    'landing.{lang=it}.footer.copyright': 'Epilogo SRL. Tutti i diritti riservati.',
    'landing.{lang=en}.footer.copyright': 'Epilogo SRL. All rights reserved.',
  },
});
